import { ProductSearchCommandModel } from "../product-base-model";

export class SpecialServiceSearchCommandModel extends ProductSearchCommandModel {
    public seasonCode: string;
}